import { useState, useEffect } from 'react'
import { getCauses, getOurCauses } from '@services/CausesService'
import { Cause } from '@Interfaces/Data/CauseInterface'
import { User } from '@Interfaces/Data/UserInterface'
import { UseCausesDataReturn } from '@Interfaces/Hooks/DataInterface'

export const useCausesData = (currentUser: User | null): UseCausesDataReturn => {
  const [allCauses, setAllCauses] = useState<Cause[]>([])
  const [ourCauses, setOurCauses] = useState<Cause[]>([])

  useEffect(() => {
    getCauses().then((response) => {
      if (response.success && response.data) {
        setAllCauses(response.data)
      }
    })
  }, [])

  useEffect(() => {
    if (currentUser && allCauses.length > 0) {
      const causeIds = currentUser.causes || []
      const filtered = getOurCauses(causeIds, allCauses)
      setOurCauses(filtered)
    }
  }, [currentUser?.id, allCauses.length])

  return {
    allCauses,
    setAllCauses,
    ourCauses,
    setOurCauses,
  }
}
